import axios from "axios";

const endpoint = `${process.env.REACT_APP_API_URL}/EvaluationReponseController/mes_equipes_dernieres_evaluations/`;

export async function getMesEquipes(params, signal) {
  const response = await axios.get(endpoint, { params, signal });
  if (!response.data?.success || !Array.isArray(response.data.data)) {
    throw new Error(response.data?.message || "Impossible de charger les equipes.");
  }
  return response.data;
}

export async function getMesEquipesForExport(params) {
  const first = await getMesEquipes({ ...params, page: 1, page_size: 50 });
  const rows = [...first.data];
  for (let page = 2; page <= Math.ceil(first.pagination.total / 50); page += 1) {
    const next = await getMesEquipes({ ...params, page, page_size: 50 });
    rows.push(...next.data);
  }
  return rows;
}
